var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseAuthManager } from 'smartpi-core';
import { LocalStorage } from './storage';
var localStorage = new LocalStorage('auth');
var AuthManager = /** @class */ (function (_super) {
    __extends(AuthManager, _super);
    function AuthManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthManager.prototype.setStorage = function (key, value) {
        localStorage.setItem(key, value);
    };
    AuthManager.prototype.getStorage = function (key) {
        return localStorage.getItem(key);
    };
    AuthManager.prototype.clearStorage = function (key) {
        localStorage.removeItem(key);
    };
    return AuthManager;
}(BaseAuthManager));
export { AuthManager };
//# sourceMappingURL=auth.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/services/auth.js
// module id = 164
// module chunks = 0